import { render, staticRenderFns } from "./InkjetThresholdFormModal.vue?vue&type=template&id=51b21f39&"
import script from "./InkjetThresholdFormModal.ts?vue&type=script&lang=js&"
export * from "./InkjetThresholdFormModal.ts?vue&type=script&lang=js&"
import style0 from "./InkjetThresholdFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports